import { useTranslation } from "react-i18next";
import { useCookieConsentStore } from "../store/cookieConsent";

export function CookieConsent() {
  const { status, accept, reject } = useCookieConsentStore();
  const { t } = useTranslation("common");

  if (status !== "pending") return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 sm:p-6">
      <div className="mx-auto max-w-3xl rounded-2xl border border-border/50 bg-card/95 p-4 shadow-xl backdrop-blur-md sm:p-6">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-sm text-muted-foreground">
            {t("cookieConsent.message")}{" "}
            <a
              href="/privacy"
              className="underline underline-offset-2 hover:text-foreground transition-colors"
            >
              {t("cookieConsent.privacyLink")}
            </a>
          </p>
          <div className="flex shrink-0 gap-2">
            <button
              onClick={reject}
              className="rounded-lg border border-border px-4 py-2 text-sm font-medium text-muted-foreground transition-colors hover:bg-muted hover:text-foreground"
            >
              {t("cookieConsent.reject")}
            </button>
            <button
              onClick={accept}
              className="rounded-lg bg-primary px-4 py-2 text-sm font-medium text-primary-foreground transition-colors hover:bg-primary/90"
            >
              {t("cookieConsent.accept")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
